import firebaseConfig from '@/config/firebase'
import firebase from '@/helpers/firebase'
import ClickOutsideDirective from '@/plugins/ClickOutsideDirective'
import FontAwesome from '@/plugins/FontAwesome'
import PageScrollDirective from '@/plugins/PageScrollDirective'
import VeeValidatePlugin from '@/plugins/VeeValidatePlugin'
import Vue3Pagination from '@/plugins/Vue3Pagination'
import router from '@/router'
import store from '@/store'
import { createHead } from '@vueuse/head'
import { createApp } from 'vue'
import App from './App.vue'

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

const forumApp = createApp(App)
forumApp.use(router)
forumApp.use(store)
forumApp.use(FontAwesome)
forumApp.use(ClickOutsideDirective)
forumApp.use(PageScrollDirective)
forumApp.use(Vue3Pagination)
forumApp.use(VeeValidatePlugin)
forumApp.use(createHead())

const requireComponent = require.context('./components', true, /App[A-Z]\w+\.(vue|js)$/)
requireComponent.keys().forEach(function (fileName) {
  let baseComponentConfig = requireComponent(fileName)
  baseComponentConfig = baseComponentConfig.default || baseComponentConfig
  const baseComponentName = baseComponentConfig.name || (
    fileName
      .replace(/^.+\//, '')
      .replace(/\.\w+$/, '')
  )
  forumApp.component(baseComponentName, baseComponentConfig)
})

forumApp.mount('#app')
